// extracted by mini-css-extract-plugin
export default {"formRow":"ForgotPassword_formRow__d876k","input":"ForgotPassword_input__vdx3n","buttonRow":"ForgotPassword_buttonRow__D95km"};